module.exports = __webpack_public_path__ + "img/pension_create.67afcc01.png";